<script>
import { mapGetters } from 'vuex';
import { EquirectGeometry, ImageUrlSource, RectilinearView } from 'marzipano';
import { EMPTY_IMAGE } from '@/utils/enum';

export default {
  name: 'MarzipanoScene',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      scene: undefined,
    };
  },
  computed: {
    ...mapGetters('nativePanorama', ['generatePredefines', 'hotspot', 'viewYaw']),
    active() {
      return this.hotspot.id === this.data.id;
    },
  },
  watch: {
    viewYaw(value) {
      if (this.active && value !== undefined) {
        this.scene.view().setYaw(value);
      }
    },
    active(value) {
      if (value) {
        this.emitViewYaw();
      }
    }
  },
  render(h) {
    if (!this.scene) {
      this.scene = this.createScene();
    }

    return h('div', { class: 'marzipano-scene-container' }, this.$slots.default);
  },
  methods: {
    createScene() {
      const {
        data,
        $parent: { viewer },
      } = this;
      const predefines = this.generatePredefines(data);
      const source = ImageUrlSource.fromString(data.image || EMPTY_IMAGE);
      const geometry = new EquirectGeometry(predefines.geometry.levels);
      const limit = RectilinearView.limit.traditional(
        predefines.view.limit.maxResolution,
        predefines.view.limit.maxVFox,
      );
      const view = new RectilinearView(predefines.view.params, limit);

      view.addEventListener('change', view => this.emitViewYaw(view));

      return viewer.createScene({
        source,
        geometry,
        view,
        pinFirstLevel: true,
      });
    },
    emitViewYaw(view = this.scene.view()) {
      if (this.active) {
        this.$root.$emit('view-yaw', view.yaw());
      }
    }
  },
};
</script>

<style scoped>
.marzipano-scene-container {
  display: none;
}
</style>
